export const isNumber = (value: any): value is number => typeof value === 'number';
